import { checkboxColDefCreator, dateColDefCreator, employeeColDefCreator, modifyButtonColDefCreator, numberColDefCreator, stringColDefCreator } from "./standard-col-def-creators"
import { ValueGetterParams } from "ag-grid-community"
import { tContext } from "../types"
import { WorkRuleSetRule } from "../../../forms/WorkRuleSetForm/work_rules"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getWorkRuleSetsSettings = () => {
    return {
        tableName: "Work Rule Sets",
        navId: "workRuleSets",
        resources: ["workRuleSets"],
        additionalQueryParams: {
            include_item_count: true,
        },
        relatedNames: {
            workRuleSets: {
                employees: ["/created_by"],
            },
        },
        filters: [],
        colDefs: [
            checkboxColDefCreator({
                width: 60,
                headerCheckboxSelection: true,
            }),
            stringColDefCreator({
                headerName: "Name",
                maxLength: 100,
                width: 225,
                field: "/name",
            }),
            stringColDefCreator({
                headerName: "Description",
                field: "/description",
            }),
            numberColDefCreator({
                headerName: "Rules",
                editable: false,
                valueGetter: (params: ValueGetterParams) => params.data.work_rules?.filter((r: WorkRuleSetRule) => r.enabled !== "disabled").length || 0,
            }),
            {
                ...numberColDefCreator({
                    headerName: "Projects",
                    editable: false,
                    valueGetter: (params: ValueGetterParams) => params.data.project_names.length,
                }),
                customTooltip: (params: ValueGetterParams) => ({
                    tooltipShouldRender: params.data.project_names.length > 0,
                    data: { list: params.data.project_names },
                }),
            },
            {
                ...numberColDefCreator({
                    headerName: "Groups",
                    editable: false,
                    valueGetter: (params: ValueGetterParams) => params.data.group_names.length,
                }),
                customTooltip: (params: ValueGetterParams) => ({
                    tooltipShouldRender: params.data.group_names.length > 0,
                    data: { list: params.data.group_names },
                }),
            },
            dateColDefCreator({
                headerName: "Last Updated",
                field: "/last_updated",
                editable: false,
            }),
            employeeColDefCreator({
                headerName: "Created By",
                field: "/created_by",
                width: 150,
                editable: false,
            }),
            {
                ...modifyButtonColDefCreator({
                    modifyFlow: "WORK_RULE_SETS_MODIFY",
                    headerName: "Settings",
                    editable: true,
                }),
                field: "/settings",
                // Prevent AG-Grid from intercepting clicks meant for the Modify button
                editable: false,
                excludeFromExport: true,
            },
        ],
        gridSettings: {
            rowHeight: 40,
            defaultColDef: {
                editable: true,
                filter: true,
                sortable: false,
            },
            rowSelection: "multiple",
        },
        otherSettings: {
            hiddenColumnDefaults: {
                sort_order: {
                    value: 0,
                },
            },
            buttons: {
                cell: [],
                row: [
                    {
                        label: "Duplicate",
                        icon: "copy",
                        action: "duplicateRow",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN" || context.selectedRows.length > 1,
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) =>
                            context.currentUser.employee.user_role !== "ADMIN"
                                ? "Only Admins can perform this operation"
                                : context.selectedRows.length > 1
                                ? "You may only duplicate one row at a time"
                                : "Copy the selected work rule set",
                    },
                    {
                        label: "Delete",
                        icon: "delete",
                        action: "deleteSelectedRows",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) => (context.currentUser.employee.user_role !== "ADMIN" ? "Only Admins can perform this operation" : "Delete the selected work rule set"),
                    },
                ],
                table: [
                    {
                        label: "Create",
                        icon: "add",
                        action: "addWorkRuleSet",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        disabled: (context: tContext) => context.currentUser.employee.user_role !== "ADMIN",
                        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                        tooltip: (context: tContext) => (context.currentUser.employee.user_role !== "ADMIN" ? "Only Admins can perform this operation" : "Create a new work rule set"),
                    },
                ],
            },
        },
    }
}
